import React from "react";
import { get, uniqBy } from "lodash";
import { Helmet } from "react-helmet";
import TrayItem from "../Tray/Video/trayItem";
import Spinner from "~/components/Spinner";
import { axiosWithKey } from "~/axios";
import { getToken } from "~/redux/user/tokens";
import userLanguageSelector from "~/tools/localization/userLanguageSelector";
import "./styles.css";

import withInfiniteScrolling from "~/tools/withInfiniteScrolling";

class CategoryPage extends React.Component {
  fetchData = async () => {
    const moduleType = this.props.data.moduleType;

    if (moduleType === "CuratedTrayModule") {
      return [];
    }

    const token = await getToken();

    const content = await axiosWithKey.get(
      `${window.settings.apiBaseUrl}/content/pages`,
      {
        params: {
          path: window.location.pathname,
          modules: this.props.data.id,
          includeContent: true,
          offset: this.props.items.length,
          languageCode: userLanguageSelector(),
          sortBy: get(this.props, "data.filters.sortBy", "title")
        },
        headers: { Authorization: token }
      }
    );

    return get(content, "data.modules[0].contentData", []);
  };

  render() {
    const settings = get(this.props, "layout.settings");
    const { categories, tags } = get(this.props, "data.filters") || {};
    const title = (categories && categories[0]) || (tags && tags[0]) || "";
    const items = uniqBy(this.props.items, "id");

    return (
      <div className="category-page">
        <Helmet>
          <title>{`${title} | ${window.settings.site}`}</title>
        </Helmet>

        <h1 className={`category-page-title site-color `}>
          {title || this.props.data.title}
        </h1>

        <div
          className={
            "category-page-grid " +
            (settings.thumbnailType ? settings.thumbnailType : "") +
            (settings.columns && settings.columns.desktop
              ? ` items-on-desktop-${settings.columns.desktop}`
              : " ") +
            (settings.columns && settings.columns.tablet
              ? ` items-on-tablet-${settings.columns.tablet}`
              : " ") +
            (settings.columns && settings.columns.mobile
              ? ` items-on-mobile-${settings.columns.mobile}`
              : " ")
          }
        >
          {items.map(item => (
            <div className="grid-item" key={item.id}>
              <TrayItem item={item} thumbnailType={settings.thumbnailType} />
            </div>
          ))}
        </div>

        {this.props.fetching && <Spinner />}
      </div>
    );
  }
}

export default withInfiniteScrolling(CategoryPage);
